<template>
  <div>
    <el-form :inline="true" v-if="rightsContains('NEW_HEDGE_STRATEGY_UPDATE')">
      <el-form-item>
          <el-button type="danger" @click="dialogVisible=true">新增策略</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="dialogVisible1=true">修改对冲买卖开关</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="dialogVisible2=true">批量修改回撤</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="新增策略" :visible.sync="dialogVisible" width="75%" @close="clearData" :close-on-click-modal="false">
      <el-form :model="strategyData" label-width="120px" :label-position="'right'">
        <el-form-item label="对冲产品">
          <el-select v-model="strategyData.hedgeProductType" placeholder="请选择对冲产品">
            <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对冲目标类型">
          <el-select v-model="strategyData.hedgeTargetType" placeholder="请选择对冲产品">
            <el-option v-if="strategyData.hedgeProductType==='SPOT'" v-for="item in hedgeTargetTypeEnum_SPOT" :key="item.key" :label="item.label" :value="item.key"></el-option>
            <el-option v-if="strategyData.hedgeProductType==='SUPER_CONTRACT'" v-for="item in hedgeTargetTypeEnum_SUPER_CONTRACT" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对冲目标值">
          <el-input v-model="strategyData.hedgeTargetValue" placeholder="请输入对冲目标值" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="合并时间周期">
          <el-input v-model="strategyData.mergeHedgeCycleTime" placeholder="请输入合并周期，时间以分钟为单位" type="number" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="合并对冲金额">
          <el-input v-model="strategyData.mergeHedgeCycleAmount" placeholder="请输入合并对冲金额" type="number" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="失败最大次数">
          <el-input v-model="strategyData.maxFailTimes" placeholder="请输入失败最大次数" type="number" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="买方向价格回撤">
          <el-input v-model="strategyData.bidPriceDiscount" placeholder="请输入买方向价格回撤" type="number" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="卖方向价格回撤">
          <el-input v-model="strategyData.askPriceDiscount" placeholder="卖方向价格回撤" type="number" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="对冲比例">
          <el-input v-model="strategyData.hedgePercentage" placeholder="请输入买方向价格回撤" type="number" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="币对等级">
          <el-input v-model="strategyData.currencyPairLevel" placeholder="请输入币对等级" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="买开关：">
          <el-switch
              v-model="strategyData.buySwitch"
              active-text="开"
              inactive-text="关">
          </el-switch>
        </el-form-item>
        <el-form-item label="卖开关：">
          <el-switch
              v-model="strategyData.sellSwitch"
              active-text="开"
              inactive-text="关">
          </el-switch>
        </el-form-item>
        <el-form-item label="对冲账号">
          <el-checkbox-group v-model="strategyData.exchangeCheckBox" :min="1" :max="10">
            <el-checkbox v-for="item in hedgeAccountEnum" :label="item.key" name="type" border style="width: 150px" size="small"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addStrategy">立即创建</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改对冲买开关" :visible.sync="dialogVisible1" width="60%" @close="clearData" :close-on-click-modal="false">
      <el-form :model="switchData" label-width="120px" :label-position="'right'">
        <el-form-item label="交易对">
          <el-input v-model="switchData.pair" placeholder="多个交易对使用英文逗号分割，不传则全部设置" clearable></el-input>
        </el-form-item>
        <el-form-item label="买开关">
          <el-select v-model="switchData.buySwitch" placeholder="请选择买开关">
            <el-option label="请选择" value=""></el-option>
            <el-option label="开启" value="true"></el-option>
            <el-option label="关闭" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卖开关">
          <el-select v-model="switchData.sellSwitch" placeholder="请选择卖开关">
            <el-option label="请选择" value=""></el-option>
            <el-option label="开启" value="true"></el-option>
            <el-option label="关闭" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updateSwitch">立即执行</el-button>
          <el-button @click="dialogVisible1=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改回撤" :visible.sync="dialogVisible2" width="60%" @close="clearData" :close-on-click-modal="false">
      <el-form :model="retracementData" label-width="120px" :label-position="'right'">
        <el-form-item label="对冲目标类型">
          <el-select v-model="retracementData.hedgeTargetType" placeholder="请选择对冲目标类型">
            <el-option v-if="strategyData.hedgeProductType==='SPOT'" v-for="item in hedgeTargetTypeEnum_SPOT" :key="item.key" :label="item.label" :value="item.key"></el-option>
            <el-option v-if="strategyData.hedgeProductType==='SUPER_CONTRACT'" v-for="item in hedgeTargetTypeEnum_SUPER_CONTRACT" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对冲目标值">
          <el-input v-model="retracementData.pair" placeholder="多个对冲目标值使用英文逗号分割，不传则全部设置" clearable></el-input>
        </el-form-item>
        <el-form-item label="买方向价格回撤">
          <el-input v-model="retracementData.bidPriceDiscount" placeholder="请输入买方向价格回撤" type="number" clearable></el-input>
        </el-form-item>
        <el-form-item label="卖方向价格回撤">
          <el-input v-model="retracementData.askPriceDiscount" placeholder="卖方向价格回撤" type="number" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updateBatchRetracement">立即执行</el-button>
          <el-button @click="dialogVisible2=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-form :inline="true">
      <el-form-item label="对冲产品:">
        <el-select v-model="requestData.hedgeProductType" placeholder="请选择对冲产品">
          <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲目标类型:">
        <el-select v-model="requestData.hedgeTargetType" placeholder="请选择对冲目标类型">
          <el-option v-if="requestData.hedgeProductType==='SPOT'" v-for="item in hedgeTargetTypeEnum_SPOT" :key="item.key" :label="item.label" :value="item.key"></el-option>
          <el-option v-if="requestData.hedgeProductType==='SUPER_CONTRACT'" v-for="item in hedgeTargetTypeEnum_SUPER_CONTRACT" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲目标值:">
          <el-input v-model="requestData.hedgeTargetValueList" placeholder="请选择对冲目标类值"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :plain="true" @click="searchStrategy">查找</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" border style="width: 100%" v-if="rightsContains('NEW_HEDGE_STRATEGY_READ') || rightsContains('APPROVE_DEPOSIT_UPDATE')">
      <el-table-column fixed prop="id" label="ID" sortable width="60"></el-table-column>
      <el-table-column prop="hedgeProductType" label="对冲产品" sortable width="100"></el-table-column>
      <el-table-column prop="hedgeTargetType" label="对冲目标类型" sortable width="120"></el-table-column>
      <el-table-column prop="hedgeTargetValue" label="对冲目标值" sortable width="100"></el-table-column>
<!--      <el-table-column label="对冲产品" sortable width="150">-->
<!--        <template slot-scope="scope">-->
<!--          <el-input :value="scope.row.hedgeProductType" style="width:130px"-->
<!--                    @change="setThreshold(scope.row,'hedgeProductType',$event)"/>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="对冲目标类型" sortable width="180">-->
<!--        <template slot-scope="scope">-->
<!--          <el-input :value="scope.row.hedgeTargetType" style="width:160px"-->
<!--                    @change="setThreshold(scope.row,'hedgeTargetType',$event)"/>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="对冲目标值" sortable width="150">-->
<!--        <template slot-scope="scope">-->
<!--          <el-input :value="scope.row.hedgeTargetValue" style="width:130px"-->
<!--                    @change="setThreshold(scope.row,'hedgeTargetValue',$event)"/>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column prop="" label="对冲账号" sortable width="250">
        <template slot-scope="scope">
          <el-input :value="scope.row.exchangeList" style="width:230px"
                    @change="setThreshold(scope.row,'exchangeList',$event)"/>
        </template>
      </el-table-column>
      <el-table-column label="合并时间周期" sortable width="120">
        <template slot-scope="scope">
          <el-input :value="scope.row.mergeHedgeCycleTime" style="width:100px" type="number"
                    @change="setThreshold(scope.row,'mergeHedgeCycleTime',$event)"/>
        </template>
      </el-table-column>
      <el-table-column label="合并对冲金额" sortable width="120" >
        <template slot-scope="scope">
          <el-input :value="scope.row.mergeHedgeCycleAmount" style="width:100px" type="number"
                    @change="setThreshold(scope.row,'mergeHedgeCycleAmount',$event)"/>
        </template>
      </el-table-column>
      <el-table-column label="买方价格回撤" sortable width="120">
        <template slot-scope="scope">
          <el-input :value="scope.row.bidPriceDiscount" style="width:100px" type="number"
                    @change="setThreshold(scope.row,'bidPriceDiscount',$event)"/>
        </template>
      </el-table-column>
      <el-table-column label="卖方价格回撤" sortable width="120">
        <template slot-scope="scope">
          <el-input :value="scope.row.askPriceDiscount" style="width:100px" type="number"
                    @change="setThreshold(scope.row,'askPriceDiscount',$event)"/>
        </template>
      </el-table-column>
      <el-table-column label="对冲比例" sortable width="120">
        <template slot-scope="scope">
          <el-input :value="scope.row.hedgePercentage" style="width:100px" type="number"
                    @change="setThreshold(scope.row,'hedgePercentage',$event)"/>
        </template>
      </el-table-column>
      <el-table-column label="失败最大次数" sortable width="120">
        <template slot-scope="scope">
          <el-input :value="scope.row.maxFailTimes" style="width:100px" type="number"
                    @change="setThreshold(scope.row,'maxFailTimes',$event)"/>
        </template>
      </el-table-column>
      <el-table-column label="买开关" sortable width="120">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.buySwitch"
              active-text="开"
              inactive-text="关"
              @change="setThreshold(scope.row,'buySwitch',$event)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="卖开关" sortable width="120">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.sellSwitch"
              active-text="开"
              inactive-text="关"
              @change="setThreshold(scope.row,'sellSwitch',$event)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="币对等级" sortable width="120">
        <template slot-scope="scope">
          <el-input :value="scope.row.currencyPairLevel" style="width:100px"
                    @change="setThreshold(scope.row,'currencyPairLevel',$event)"/>
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" label="创建时间" sortable width="90"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" sortable width="90"></el-table-column>
      <el-table-column label="运行" sortable v-if="rightsContains('NEW_HEDGE_STRATEGY_UPDATE')">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isOpen"  :active-value=1 :inactive-value=0 @change="updateStatus(scope.row, $event)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="210" v-if="rightsContains('NEW_HEDGE_STRATEGY_UPDATE')">
        <template slot-scope="scope">
          <el-button @click="updateStrategy(scope.row)" type="success" size="small">更新策略</el-button>
          <el-button @click="open(scope.row)" type="danger" size="small">删除策略</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
                   layout="total, sizes, prev, pager, next, jumper"
                   :page-size="pageSize"
                   :page-sizes="[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                   :total="total"
                   :current-page="currentPageNum"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange">
    </el-pagination>
    <div style="margin: 20px 0 20px 0; text-align: right">
      <el-button type="primary" :plain="true" @click="exportAllExcel">全量导出excel</el-button>
      <el-button type="primary" :plain="true" @click="exportExcel">当前页导出excel</el-button>
    </div>
  </div>
</template>

<script>
import './store'
import api from './hedgeApi';
import '@/entries/Machine/cache'
import {mapState, mapActions} from "vuex";
import {RIGHTS_TYPE} from "@/common/constant";
import utils from "@/entries/HedgeCenter/MarketSheet/utils";

const hedgeTargetTypeEnum_SPOTOp = [
  {key: '',label:''},
  {key:'SPOT_PAIR_COMMON', label:'现货匹配交易对'},
  {key:'SPOT_PAIR_API', label:'现货只匹配交易对的API的部分，优先级SPOT'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  // {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeEnum_SUPER_CONTRACTOp=[
  {key: '',label:''},
  {key:'SC_PAIR', label:'超级合约的交易对'},
  {key:'SC_USER_ID', label:'超级合约的交易对用户ID'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  // {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]

const columns=[
  {title:'ID',key:'id'},
  {title:'对冲产品',key:'hedgeProductType'},
  {title:'对冲目标类型',key:'hedgeTargetType'},
  {title:'对冲目标值',key:'hedgeTargetValue'},
  {title:'对冲账号',key:'exchangeList'},
  {title:'合并时间周期',key:'mergeHedgeCycleTime'},
  {title:'合并对冲金额',key:'mergeHedgeCycleAmount'},
  {title:'买方价格回撤',key:'bidPriceDiscount'},
  {title:'卖方价格回撤',key:'askPriceDiscount'},
  {title:'对冲比例',key:'hedgePercentage'},
  {title:'失败最大次数',key:'maxFailTimes'},
  {title:'创建时间',key:'createdTime'},
  {title:'更新时间',key:'updateTime'},
  {title:'运行',key:'isOpen'}
]

export default {
  name: "HedgeStrategy",
  data() {
    return {
      pages:0,
      pageSize: 20,
      total:0,
      currentPageNum:1,
      tableData:[],
      accountData:[],
      requestData:{hedgeProductType:'', hedgeTargetValueList:'', hedgeTargetType:'', pageNum:1, pageSize:20},
      hedgeTargetTypeEnum_SPOT:hedgeTargetTypeEnum_SPOTOp,
      hedgeTargetTypeEnum_SUPER_CONTRACT:hedgeTargetTypeEnum_SUPER_CONTRACTOp,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      strategyData: {
        hedgeProductType: '',
        hedgeTargetType:'',
        hedgeTargetValue:'',
        mergeHedgeCycleTime: '',
        mergeHedgeCycleAmount:'',
        maxFailTimes: 3,
        askPriceDiscount:0.002,
        bidPriceDiscount:0.002,
        exchangeList:[],
        exchangeCheckBox:["BINANCE"],
        hedgePercentage:1,
        buySwitch:true,
        sellSwitch:true,
        currencyPairLevel:'',
      },
      switchData: {
        pair:'',
        buySwitch:null,
        sellSwitch:null,
      },
      retracementData: {
        pair:'',
        askPriceDiscount: null,
        bidPriceDiscount: null,
        hedgeTargetType: null,
      }
    }
  },
  computed: {
    ...mapState(["userInfo", "userRights"]),
    ...mapState('newHedgeStore', ['hedgeAccountEnum', 'hedgeProductTypeOptions']),
  },
  watch:{
    'strategyData.hedgePercentage'(val){
      if(val < 0.1){
        this.$message.warning("对冲比例不能小于0.1")
      }
    },
  },
  created() {
    this.strategyData.hedgeProductType = this.hedgeProductTypeOptions[0].key
    this.requestData.hedgeProductType = this.hedgeProductTypeOptions[0].key
    this.searchStrategy()
    this.rightsContains()
  },
  methods: {
    setThreshold(data, name, value) {

      if (name === 'mergeHedgeCycleTime'){
        if(value < 0){
          this.$message.warning("警告：合并时间周期不小于0")
          return
        }
      }
      if (name === 'mergeHedgeCycleAmount'){
        if(value < 0){
          this.$message.warning("警告：合并对冲金额不小于0")
          return
        }
      }
      if (name === 'hedgePercentage'){
        if(value < 0.1){
          this.$message.warning("警告：对冲比例不小于0.1")
          return
        }
      }
      if (name === 'maxFailTimes'){
        if(value < 0){
          this.$message.warning("警告：失败最大次数不小于0")
          return
        }
      }
      data[name] = value
    },
    rightsContains(r) {
      let rights = this.userRights.split(",") || [];
      return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
    },
    updateStatus(data) {
      api.updateStrategyStatus(data).then((response)=>{
        if (response.data === true){
          this.$message.success("更新成功")
        }else{
          this.$message.error("更新失败")
        }
      })
    },
    updateStrategy(data){
      api.updateStrategy(data).then((response)=>{
        if (response.code === 0) {
          this.dialogVisible = false;
          this.$message.success('更新成功');
        } else {
          this.$message.error('更新失败');
        }
      })
    },
    removeStrategy(data){
      api.removeStrategy(data).then((response)=>{
        if (response.data === true){
          this.dialogVisible = false;
          this.$message.success('删除策略成功');
          this.searchStrategy()
        }else{
          this.$message.error('删除策略失败')
        }
      })
    },
    open(data) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        api.removeStrategy(data).then((response)=>{
          if (response.data === true){
            this.dialogVisible = false;
            this.$message.success('删除成功');
            this.searchStrategy()
          }else{
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    handleSizeChange(val){
      this.requestData.pageSize = val
      this.searchStrategy()
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val
      this.searchStrategy()
    },

    exportExcel() {
      let localTime = utils.getLocalTime(new Date().getTime())
      let title = '对冲策略' + localTime
      utils.export2Excel(columns,this.tableData,title)
    },

    exportAllExcel(){
      api.queryAllHedgeStrategies().then((resp)=>{
        let tableData = resp.data
        for (let key in tableData){
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
          tableData[key].createdTime = utils.getLocalTime(tableData[key].createdTime)
        }
        let localTime = utils.getLocalTime(new Date().getTime())
        let title = '对冲策略' + localTime
        utils.export2Excel(columns, tableData, title)
      })
    },
    searchStrategy(){
      api.queryStrategyList(this.requestData).then((response)=>{
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current
        let tableData = response.data.records
        for (let key in tableData){
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
          tableData[key].createdTime = utils.getLocalTime(tableData[key].createdTime)
        }
        this.tableData = tableData
      })
    },
    addStrategy() {
      if (!this.strategyData.hedgeTargetValue){
        this.$message.error('请输入最冲目标值')
        return
      }
      if (!this.strategyData.mergeHedgeCycleTime) {
        this.$message.error('请输入合并周期（时间以分钟为单位）');
        return;
      }
      if (!this.strategyData.mergeHedgeCycleAmount) {
        this.$message.error('请输入横对冲金额');
        return;
      }
      if (!this.strategyData.maxFailTimes) {
        this.$message.error('请输入最大失败次数');
        return;
      }
      if (!this.strategyData.bidPriceDiscount) {
        this.$message.error('请输入买方向的价格回撤');
        return;
      }
      if (!this.strategyData.askPriceDiscount) {
        this.$message.error('请输入卖方向的价格回撤');
        return;
      }
      if (!this.strategyData.hedgePercentage) {
        this.$message.error('请输入对冲比例');
        return;
      }
      if (this.strategyData.exchangeCheckBox.length === 0) {
          this.$message.error('请勾选交易所');
          return;
      }
      this.strategyData.exchangeList = this.strategyData.exchangeCheckBox.join(',')
      api.addStrategy(this.strategyData).then(response => {
        if (response.code === 0) {
          this.dialogVisible = false;
          this.$message.success('增加策略成功');
          this.searchStrategy()
        } else {
          this.$message.error('增加策略失败');
        }
      })
    },
    updateSwitch(){
      if (!this.switchData.buySwitch && !this.switchData.sellSwitch){
        this.$message.error('买开关或者卖开关必须选择一个')
        return
      }

      api.updateSwitch(this.switchData).then(response => {
        if (response.code === 0) {
          this.dialogVisible1 = false;
          this.$message.success('修改开关成功');
          this.searchStrategy()
        } else {
          this.$message.error('修改开关失败');
        }
      })
    },
    updateBatchRetracement(){
      if (!this.retracementData.bidPriceDiscount && !this.retracementData.askPriceDiscount){
        this.$message.error('买回撤或者卖回撤必须有一个不为空')
        return
      }

      api.updateBatchRetracement(this.retracementData).then(response => {
        if (response.code === 0) {
          this.dialogVisible2 = false;
          this.$message.success('批量修改回测成功');
          this.searchStrategy()
        } else {
          this.$message.error('批量修改回测失败');
        }
      })
    },
    clearData() {
      this.strategyData = {
        hedgeProductType: 'SPOT',
        hedgeTargetType:'',
        hedgeTargetValue:'',
        mergeHedgeCycleTime: '',
        mergeHedgeCycleAmount:'',
        maxFailTimes: 3,
        askPriceDiscount:0.002,
        bidPriceDiscount:0.002,
        exchangeList:[],
        hedgePercentage:1,
        exchangeCheckBox:["BINANCE"],
        buySwitch:true,
        sellSwitch:true,
        currencyPairLevel:'',
      },
      this.switchData = {
        pair:'',
        buySwitch:null,
        sellSwitch:null,
      },
      this.retracementData= {
        pair:'',
        askPriceDiscount:null,
        bidPriceDiscount:null,
        hedgeTargetType: null,
      }
    },
  }
}
</script>

<style scoped>
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
</style>
